import { BackLink as DdsBackLink } from '@norges-domstoler/dds-components';
import { MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

type BackLinkProps = {
  href?: string;
  children?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export function BackLink({ href, children, ...rest }: BackLinkProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();

      if (href) {
        navigate(href);
      }
    },
    [href, navigate]
  );

  const label = children ?? t('back');

  return (
    <div className="mb-4 inline-flex">
      <DdsBackLink
        href={href}
        label={label.toString()}
        onClick={rest.onClick ?? onClick}
      />
    </div>
  );
}
